module.exports = __webpack_public_path__ + "static/media/school_4.42c5724d.jpg";